<script setup lang="ts">
import { markLoggedOut } from "../utils/useAuth";

import { useRouter } from "vue-router";
import { reactive, onMounted } from "vue";
import AxiosUserService from "../utils/axiosUserService";

const router= useRouter();
const axiosUserService = new AxiosUserService();

const user = reactive({
    user_role: "",
    avatar: "",
    srcValue: "/avatar-default.png",
})
function getUser(){
    axiosUserService.getCurrentUser(localStorage.token)
    .then(function (res) {      
        user.user_role = res.data.user_role
    
        // console.log('Current User Role',user.user_role)
    }).catch(function (res) {
        console.log('Current User error',res)    
    })
}

const logout = () =>{
    localStorage.removeItem("token")
    axiosUserService.logout(localStorage.token)
    .then(function (res) {
        markLoggedOut()

        router.push("/admin/login");
           
   }).catch(function (res) {

       console.log('logout',res)
       router.push("/admin/login");

   })

}

const openMenu = () =>{
    const d_sidebar:HTMLDivElement = document.querySelector('.d_sidebar') as HTMLDivElement
    d_sidebar.classList.add('open')

    onmouseup = (event: any) => { 
        if(d_sidebar !== event.target && !d_sidebar.contains(event.target)){
            d_sidebar.classList.remove("open");
        }
    };
}

onMounted(()=>{
    getUser()
})
</script>

<template>
    <nav class="d_sidebar transition flex column j-between a-start scroll" :class="user.user_role == 'Member' ? 'sd': ''">
        <div>

            <div class="navList">
                <div class="flex a-center gap-10">
                    <a href="/">
                        <img src="/new_mimir.png" alt="the Mimir">
                    </a>
                    <div class="tag" :class="user.user_role == 'Member' ? 'white bg-sd' : 'pr'">{{ user.user_role }}</div>
                </div>
                <router-link class="navItem" to="/user/dashboard">
                    <span class="icon-dashboard"></span>
                    <span>Dashboard</span>
                </router-link>
                <!-- <router-link class="navItem" to="/user/debate">
    
                    <span class="icon-host"></span>
                    <span>Debate</span>
                </router-link> -->
                <router-link class="navItem" to="/user/profile" v-if="user.user_role == 'Mentor'">
    
                    <span class="icon-setting"></span>
                    <span>Account Setting</span>
                </router-link>
                <router-link class="navItem" to="/user/account" v-if="user.user_role !== 'Mentor'">
    
                    <span class="icon-setting"></span>
                    <span>Account Setting</span>
                </router-link>
                <router-link class="navItem" to="/user/discussion">
    
                    <span class="icon-discussion"></span>
                    <span>Discussion</span>
                </router-link>
                <router-link class="navItem" to="/user/activities">
    
                    <span class="icon-timer"></span>
                    <span>Activites</span>
                </router-link>
                <!-- <router-link class="navItem" to="/user/chat">
                    
                    <span class="icon-message"></span>
                    <span>Chat</span>
                </router-link> -->
                <!-- <router-link class="navItem" to="/user/uploads" v-if="user.user_role == 'Mentor'">
                    <span class="icon-upload"></span>
                    <span>Uploads</span>
                </router-link> -->
                <!-- <router-link class="navItem" to="/user/download">
                    <span class="icon-download"></span>
                    <span>Download</span>
                </router-link> -->
                <router-link class="navItem" to="/user/subscription" >
                    <span class="icon-bag"></span>
                    <span>Subscription</span>
                </router-link>
                <router-link class="navItem" to="/user/saved">
    
                    <span class="icon-bookmark-regular"></span>
                    <span>Saved & History</span>
                </router-link>
                <!-- <router-link class="navItem" to="/user/archived" v-if="user.user_role == 'Free' || 'Premiun'">
                    <span class="icon-docs"></span>
                    <span>Archived</span>
                </router-link> -->
                <!-- <router-link class="navItem" to="/user/popularity" v-if="user.user_role == 'Mentor'"> 
                    <span class="icon-stage"></span>
                    <span>Popularity</span>
                </router-link> -->
                <!-- <router-link class="navItem" to="/user/curruculum" v-if="user.user_role == 'Mentor'">
                    <span class="icon-lesson"></span>
                    <span>Curruculum</span>
                </router-link> -->
            </div>
            <div class="navItem" @click="logout">
                <span class="icon-logout"></span>
                <span>Logout</span>
            </div>
        </div>

    </nav>
    <img class="mb_menu active transition abs pointer " src="/icon-menu.png" @click="openMenu">

</template>    

<style scoped>
@import '../assets/styles/dashboard.css';

.d_sidebar{
    height: 100vh;
}
</style>